import React from 'react';
import PropTypes from 'prop-types';
import Font from '@mui/icons-material/HowToReg';
import { Card, TextField } from '@totalsoft/rocket-ui';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const ApprovalTypeLevelGeneralDataComponent = ({ approvalTypeLevelItem, dispatch, validation }) => {
  const { t } = useTranslation();
  const OnPropertyChanged = (propertyName, value) => {
    dispatch({ type: 'OnHeaderPropertyChanged', propertyName, value });
  };

  return (
    <Card icon={Font} iconColor='primary' title={t('ApprovalTypes.ApprovalTypeLevel.GeneralData')}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            value={approvalTypeLevelItem.levelName || ''}
            label={t('ApprovalTypes.ApprovalTypeLevel.Level')}
            onChange={event => {
              OnPropertyChanged('levelName', event);
            }}
            error={!isValid(validation.levelName)}
            helperText={getErrors(validation.levelName)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label={t('ApprovalTypes.ApprovalTypeLevel.DefaultEmployee')}
            fullWidth
            value={approvalTypeLevelItem.defaultEmployeeName || ' '}
            disabled
          />
        </Grid>
      </Grid>
    </Card>
  );
};

ApprovalTypeLevelGeneralDataComponent.propTypes = {
  approvalTypeLevelItem: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default ApprovalTypeLevelGeneralDataComponent;
